import $ from "jquery";
import COS from "cos-js-sdk-v5";

const retryUploadCosTime = 5
let reTryUploadVideoTimes = 0;
let reTryUploadVideoTimeout;
let reTryUploadJsonTimes = 0;
let reTryUploadJsonTimeout;
let reTryUploadWavTimes = 0;
let reTryUploadWavTimeout;
let reTryUploadTxtTimes = 0;
let reTryUploadTxtTimeout;

export class Cos {

    /**
     * 获取url参数值
     * @param name
     * @returns {*}
     */
    static uploadCos(recordBlob, args) {
        reTryUploadWavTimes = 0;
        clearTimeout(reTryUploadWavTimeout);
        reTryUploadTxtTimes = 0;
        clearTimeout(reTryUploadTxtTimeout);
        //录制音频参数
        const options = {
            Bucket: 'course-wavs-1256571289',
            Region: 'ap-beijing'
        }
        const cosSignatureUrl = '/course/live/get_secret?putaoid=6F856B20-E9CF-40E5-993B-50D94882A5A6&sign=bdbb2b4f911f0e14ab953a3609d7042f&ts=1539762402&uuid=6F856B20-E9CF-40E5-993B-50D94882A5A6';

        // 初始化实例
        let cos = new COS({
            getAuthorization: function (options, callback) {
                // 异步获取签名
                $.get(cosSignatureUrl, {
                    bucket: options.Bucket,
                    region: options.Region,
                }, function (json) {
                    if (json && json.data && json.data.credentials) {
                        let data = json.data;
                        callback({
                            TmpSecretId: data.credentials.tmpSecretId,
                            TmpSecretKey: data.credentials.tmpSecretKey,
                            XCosSecurityToken: data.credentials.sessionToken,
                            ExpiredTime: data.expiredTime
                        });
                    } else {
                        try {
                            window.PTMonitor.report({
                                type: 'apiSucEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                stack: "get cos sign fail",
                                info: cosSignatureUrl
                            }, window.EX_TYPE.apiSucEx);
                        } catch (error) { }
                    }
                });
            }
        });

        //上传至cos
        let cos_filePath = args.cid;
        // let wav_fileName = `$${args.cosDate}$${args.putaoid}$-${args.session_id}-${args.uuid}-web-main.wav`;
        // let txt_fileName = `$${args.cosDate}$${args.putaoid}$-${args.session_id}-${args.uuid}-web-main.txt`;
        let wav_fileName = `$${args.cosDate}$${args.putaoid}$${args.uuid}-web-main.wav`;
        let txt_fileName = `$${args.cosDate}$${args.putaoid}$${args.uuid}-web-main.txt`;
        //上传音频
        if (recordBlob) {
            let uploadWav = () => {
                reTryUploadWavTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: cos_filePath + "/" + wav_fileName,
                    Body: recordBlob,
                    onProgress: function (info) {
                        // console.log(JSON.stringify(info));
                    }
                }, function (err, data) {
                    // console.log(err || data);
                    if (err) {
                        if (reTryUploadWavTimes < retryUploadCosTime) {
                            reTryUploadWavTimeout = setTimeout(() => {
                                uploadWav();
                            }, 2000);
                        }
                        try {
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                stack: "cos upload audio fail:" + wav_fileName,
                                info: err
                            }, window.EX_TYPE.mediaEx);
                        } catch (error) { }
                    }
                });
            }
            uploadWav();
        }

        //上传txt
        if (args && args.result) {
            let uploadTxt = () => {
                reTryUploadTxtTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: cos_filePath + "/" + txt_fileName,
                    Body: args.result,
                    onProgress: function (info) {
                        // console.log(JSON.stringify(info));
                    }
                }, function (err, data) {
                    // console.log(err || data);
                    if (err) {
                        if (reTryUploadTxtTimes < retryUploadCosTime) {
                            reTryUploadTxtTimeout = setTimeout(() => {
                                uploadTxt();
                            }, 2000);
                        }
                        try {
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                stack: "cos upload txt fail" + txt_fileName,
                                info: err
                            }, window.EX_TYPE.mediaEx);
                        } catch (error) { }
                    }
                });
            }
            uploadTxt();
        }
    }

    static uploadVideoToCos(recordBlob, args) {
        reTryUploadVideoTimes = 0;
        clearTimeout(reTryUploadVideoTimeout);
        reTryUploadJsonTimes = 0;
        clearTimeout(reTryUploadJsonTimeout);
        //录制音频参数
        const options = {
            Bucket: 'courses-replay-1256571289',
            Region: 'ap-beijing'
        }
        const cosSignatureUrl = '/course/live/get_secret?putaoid=6F856B20-E9CF-40E5-993B-50D94882A5A6&sign=bdbb2b4f911f0e14ab953a3609d7042f&ts=1539762402&uuid=6F856B20-E9CF-40E5-993B-50D94882A5A6';

        // 初始化实例
        let cos = new COS({
            getAuthorization: function (options, callback) {
                // 异步获取签名
                $.get(cosSignatureUrl, {
                    bucket: options.Bucket,
                    region: options.Region,
                }, function (json) {
                    if (json && json.data && json.data.credentials) {
                        let data = json.data;
                        callback({
                            TmpSecretId: data.credentials.tmpSecretId,
                            TmpSecretKey: data.credentials.tmpSecretKey,
                            XCosSecurityToken: data.credentials.sessionToken,
                            ExpiredTime: data.expiredTime
                        });
                    } else {
                        try {
                            window.PTMonitor.report({
                                type: 'apiSucEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                stack: "get cos sign fail",
                                info: cosSignatureUrl
                            }, window.EX_TYPE.apiSucEx);
                        } catch (error) { }
                    }
                });
            }
        });

        //上传至cos
        let cos_filePath = `pc/${args.cid}/${args.putaoid}/${args.startTime}`;
        let video_fileName = `${args.curPage}.webm`;
        let json_fileName = `${args.curPage}.json`;
        //上传video
        if (recordBlob) {
            let uploadVideo = () => {
                reTryUploadVideoTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: cos_filePath + "/video/" + video_fileName,
                    Body: recordBlob,
                    onProgress: function (progressData) {
                        if (progressData.percent === 1) {
                            console.log('v');
                        }
                    }
                }, function (err, data) {
                    // console.log(err || data);
                    if (err) {
                        if (reTryUploadVideoTimes < retryUploadCosTime) {
                            reTryUploadVideoTimeout = setTimeout(() => {
                                uploadVideo();
                            }, 2000);
                        }
                        try {
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                stack: "cos upload webm fail:" + cos_filePath + "/video/" + video_fileName,
                                info: err
                            }, window.EX_TYPE.mediaEx);
                        } catch (error) { }
                    }
                });
            }
            uploadVideo();
        }

        //上传json
        if (args && args.result) {
            let jsonResult = JSON.parse(args.result);
            if (recordBlob) {
                jsonResult.m3u8Url = `https://courses-replay-1256571289.cos.ap-beijing.myqcloud.com/${cos_filePath}/video/${args.curPage}.m3u8`;
            }
            let uploadJson = () => {
                reTryUploadJsonTimes++;
                cos.putObject({
                    Bucket: options.Bucket,
                    Region: options.Region,
                    Key: cos_filePath + "/json/" + json_fileName,
                    Body: JSON.stringify(jsonResult),
                    onProgress: function (info) {
                        // console.log(JSON.stringify(info));
                    }
                }, function (err, data) {
                    // console.log(err || data);
                    if (err) {
                        if (reTryUploadJsonTimes < retryUploadCosTime) {
                            reTryUploadJsonTimeout = setTimeout(() => {
                                uploadJson();
                            }, 2000);
                        }
                        try {
                            window.PTMonitor.report({
                                type: 'mediaEx',
                                url: window.location.href,
                                putaoid: window.PuTaoA.getCookie('putaoid'),
                                stack: "cos upload json fail:" + cos_filePath + "/json/" + json_fileName,
                                info: err
                            }, window.EX_TYPE.mediaEx);
                        } catch (error) { }
                    }
                });
            }
            uploadJson();
        }
    }

}



// WEBPACK FOOTER //
// ./src/utils/Cos.js